export const ar = {
  categories: [
    {
      id: 1,
      label: 'Cursos de Fotografía y Video',
      href: '/ar/cursos-online-fotografia-y-video/',
    },
    {
      id: 2,
      label: 'Cursos de Marketing',
      href: '/ar/cursos-online-marketing/',
    },
    {
      id: 3,
      label: 'Cursos de Modelado y Animación 3D',
      href: '/ar/cursos-online-modelado-y-animacion-3d/',
    },
    {
      id: 4,
      label: 'Cursos de Liderazgo',
      href: '/ar/cursos-online-liderazgo/',
    },
    {
      id: 5,
      label: 'Cursos de Desarrollo Productos Digitales',
      href: '/ar/cursos-online-diseno-y-desarrollo-de-productos-digitales/',
    },
  ],
  subcategories: [
    {
      id: 6,
      label: 'Cursos de Estilo de Vida',
      href: '/ar/cursos-online-estilo-de-vida/',
    },
    {
      id: 7,
      label: 'Cursos de Redes Sociales',
      href: '/ar/cursos-online-redes-sociales/',
    },
    {
      id: 8,
      label: 'Cursos de Diseño de interiores',
      href: '/ar/cursos-online-diseno-de-interiores/',
    },
    {
      id: 9,
      label: 'Cursos de Administración y finanzas',
      href: '/ar/cursos-online-administracion-y-finanzas/',
    },
    {
      id: 10,
      label: 'Cursos de Lettering',
      href: '/ar/cursos-online-lettering/',
    },
  ],
  softwares: [
    {
      id: 11,
      label: 'Cursos de Microsoft Excel',
      href: '/ar/cursos-online-microsoft-excel/',
    },
    {
      id: 12,
      label: 'Cursos de Adobe Photoshop',
      href: '/ar/cursos-online-adobe-photoshop/',
    },
    {
      id: 13,
      label: 'Cursos de After Effects',
      href: '/ar/cursos-online-adobe-after-effects/',
    },
    {
      id: 14,
      label: 'Cursos de Google Ads',
      href: '/ar/cursos-online-google-ads/',
    },
    {
      id: 15,
      label: 'Cursos de Procreate',
      href: '/ar/cursos-online-procreate/',
    },
  ],
  specializations: [
    {
      id: 17,
      label: 'UX/UI para diseño de productos',
      href: '/microdegree/ux-ui/',
    },
    {
      id: 18,
      label: 'Marketing Digital',
      href: '/microdegree/marketing-digital/',
    },
    {
      id: 19,
      label: 'Degree de Data Analytics',
      href: '/microdegree/data-analytics/',
    },
    {
      id: 20,
      label: 'Product Management',
      href: '/microdegree/product-management/',
    },
  ],
};
